/**
 * @fileoverview GET handler for the "/deliverability/email/:app_group_id/data" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { deliverabilityEmailAppGroupIdData } from "./constants";
import type {
  GetDeliverabilityEmailAppGroupIdDataParams,
  GetDeliverabilityEmailAppGroupIdDataResult,
} from "./types";

export const getDeliverabilityEmailAppGroupIdData = reactQueryFetcherAdapter(
  deliverabilityEmailAppGroupIdData,
  (
    signal: AbortSignal,
    {
      appGroupId,
      startTime,
      endTime,
      mailboxProvider,
      domain,
      ipPool,
      campaignId,
      workflowId,
    }: GetDeliverabilityEmailAppGroupIdDataParams
  ): Promise<GetDeliverabilityEmailAppGroupIdDataResult> => {
    return fetch(
      `/deliverability/email/${appGroupId}/data`,
      "GET",
      {
        start_time: startTime,
        end_time: endTime,
        mailbox_provider: mailboxProvider,
        domain,
        ip_pool: ipPool,
        campaign_id: campaignId,
        workflow_id: workflowId,
      },
      { signal },
      { propagateFetchRequestError: false }
    );
  }
);
